if (!window.__ol_site_header_2) {
  window.__ol_site_header_2 = true;
(function(){
  var cards = document.querySelectorAll('.bf-card');
  cards.forEach(function(card){
    var priceEl = card.querySelector('[data-product-field="price"]');
    var target = card.querySelector('[data-per-pair]');
    if(!priceEl || !target) return;
    var raw = (priceEl.textContent || '').replace(/[^0-9.,]/g,'');
    if(raw.indexOf(',') > -1 && raw.indexOf('.') === -1){ raw = raw.replace(',', '.'); } else { raw = raw.replace(/,/g,''); }
    var value = parseFloat(raw);
    if(!isFinite(value) || value <= 0) return;
    var cents = Math.ceil(Math.round(value * 100) / 2);
    target.textContent = '$' + (cents / 100).toFixed(2);
  });
})();
(function(){
  if(window.__sh2MenuReady) return;
  window.__sh2MenuReady = true;
  function place(menu){
    var panel = menu.querySelector('.sh2-panel');
    var header = menu.closest('.site-header-2');
    if(!panel || !header) return;
    var top = Math.max(0, header.getBoundingClientRect().bottom);
    panel.style.top = top + 'px';
    panel.style.maxHeight = Math.max(200, window.innerHeight - top) + 'px';
  }
  function setOpen(menu, open){
    var panel = menu.querySelector('.sh2-panel');
    var btn = menu.querySelector('.sh2-toggle');
    if(open){ menu.classList.add('is-open'); } else { menu.classList.remove('is-open'); }
    if(panel){
      if(open){ panel.removeAttribute('hidden'); place(menu); }
      else { panel.setAttribute('hidden', ''); }
    }
    if(btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function openMenus(){ return document.querySelectorAll('.site-header-2 .sh2-menu.is-open'); }
  document.addEventListener('click', function(e){
    var t = e.target;
    if(t && t.nodeType !== 1) t = t.parentElement;
    if(!t || !t.closest) return;
    var btn = t.closest('.site-header-2 .sh2-toggle');
    if(btn){
      e.preventDefault();
      e.stopPropagation();
      var m = btn.closest('.sh2-menu');
      if(!m) return;
      var willOpen = !m.classList.contains('is-open');
      openMenus().forEach(function(o){ if(o !== m) setOpen(o, false); });
      setOpen(m, willOpen);
      return;
    }
    var link = t.closest('.site-header-2 .sh2-panel a');
    if(link){ var lm = link.closest('.sh2-menu'); if(lm) setOpen(lm, false); return; }
    openMenus().forEach(function(m){ if(!m.contains(t)) setOpen(m, false); });
  }, true);
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    openMenus().forEach(function(m){
      setOpen(m, false); var b = m.querySelector('.sh2-toggle'); if(b) b.focus();
    });
  });
  function reposition(){ openMenus().forEach(place); }
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, { passive: true });
})();
(function(){
  document.querySelectorAll('.bf-hero').forEach(function(hero){
    var field = hero.querySelector('[data-overlay-opacity]');
    if(!field) return;
    var m = (field.textContent || '').match(/(\d+(?:[.,]\d+)?)/);
    if(!m) return;
    var n = parseFloat(m[1].replace(',', '.'));
    if(!isFinite(n)) return;
    n = Math.max(0, Math.min(100, n));
    hero.style.setProperty('--bf-overlay-opacity', String(n / 100));
  });
})();
(function(){
  var trigger = document.querySelector('[data-cart-drawer-trigger]');
  if(!trigger) return;
  function openThemeDrawer(){
    var drawer = document.querySelector('cart-drawer');
    if(drawer && typeof drawer.open === 'function'){ drawer.open(trigger); return true; }
    var themeIcon = document.querySelector('.header__icon--cart:not([data-cart-drawer-trigger]), #cart-icon-bubble:not([data-cart-drawer-trigger]), [data-cart-drawer-toggle], [data-drawer-toggle="cart"]');
    if(themeIcon && themeIcon !== trigger && themeIcon.closest('.site-header-2') === null){ themeIcon.click(); return true; }
    var alt = document.querySelector('#CartDrawer, .cart-drawer, side-drawer#cart-drawer');
    if(alt && typeof alt.open === 'function'){ alt.open(trigger); return true; }
    return false;
  }
  trigger.addEventListener('click', function(e){
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if(openThemeDrawer()) e.preventDefault();
  });
})();
(function(){
  var slides = document.querySelectorAll('.announce__slide');
  if(slides.length < 2) return;
  var i = 0;
  setInterval(function(){
    slides[i].classList.remove('is-active');
    slides[i].setAttribute('aria-hidden','true');
    i = (i + 1) % slides.length;
    slides[i].classList.add('is-active');
    slides[i].removeAttribute('aria-hidden');
  }, 3000);
})();
}
